/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { status } from 'constants/general';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'modules/common/components/Button';
import Popup from 'modules/common/components/Popup';
import ItemWithImageSearchField from 'modules/common/components/ItemWithImageSearchField';
import { fetchMedicalServices, clearMedicalServices } from 'modules/categories/categoriesSlice';
import { getServices } from 'modules/categories/api';
import { AllowEditServiceTypePriceListId } from 'constants/categories';
import { getServicesList, createQueryParam } from './helper';
import {
  PopupTitleSpan,
  PopupWrapper,
  PopupTitle,
  PopupTitleWrapper,
  Container,
  PopupTitleContainer,
  extendSearchDropDownStyle,
  extendDropDownListItem,
  extendLoaderStyle,
  ButtonsContainer,
  extendBlueButtonStyle,
  ItemsContainer,
  ItemContainer,
  ItemWrapper,
  extendShowMoreButtonStyle,
} from './AddPricelistServicesModal.style';
import ServiceRecord from './ServiceRecord';

const AddPricelistServicesModal = ({ onClose, priceListId, modalStrings, categoryKey }) => {
  const dispatch = useDispatch();
  const medicalServices = useSelector(state => state.categories.medicalServices);
  const allowEditServiceType = useSelector(
    state =>
      state.categories?.selectedPriceListDetails?.data?.priceListStrategyId ===
      AllowEditServiceTypePriceListId,
  );

  const [selectedServices, setSelectedServices] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    PageSize: 10,
    PageNum: 1,
    statuskey: 'active',
    categoryKey,
  });
  const [isShowMoreBtnShown, toggleShowMoreBtn] = useState(false);

  useEffect(() => {
    dispatch(fetchMedicalServices(searchQuery));
  }, [searchQuery]);

  useEffect(() => {
    if (medicalServices?.data?.length) {
      const servicesKeys = [];
      medicalServices?.data?.forEach(labService => {
        servicesKeys.push(labService.serviceKey);
      });

      getServices(
        `PriceListId=${priceListId}&${createQueryParam('ProductKeys', servicesKeys)}`,
      ).then(response => {
        const medicalServicesList = getServicesList(medicalServices?.data, response?.data?.data);
        toggleShowMoreBtn(medicalServices?.data.length === 10);
        setSelectedServices([...selectedServices, ...medicalServicesList]);
      });
    }
  }, [medicalServices]);

  const searchEntities = keyWord => {
    setSelectedServices([]);
    setSearchQuery({ ...searchQuery, searchterm: keyWord, PageNum: 1 });
  };

  const onClickShowMore = pageNumber => {
    setSearchQuery({ ...searchQuery, PageNum: pageNumber });
  };

  const onClickClose = () => {
    setSelectedServices([]);
    onClose();
    dispatch(clearMedicalServices());
  };

  return (
    <Popup showCloseBtn={false}>
      <PopupWrapper>
        <PopupTitleContainer>
          <PopupTitleWrapper>
            <PopupTitle>{modalStrings.title}</PopupTitle>
            <PopupTitleSpan
              onClick={() => {
                onClickClose();
              }}
            />
          </PopupTitleWrapper>
        </PopupTitleContainer>

        <Container>
          <div
            style={{
              height: '85vh',
            }}
          >
            {/** Search */}
            <div
              style={{
                padding: '16px',
                background: '#F1F4F6',
              }}
            >
              <ItemWithImageSearchField
                isRequired
                isDynamic
                isDropDown
                searchable
                key="services-search-list"
                componentName="services-search-list"
                onTypingDelay={500}
                placeHolder={modalStrings.searchBarPlaceHolder}
                fieldValue=""
                onSearch={keyWord => {
                  searchEntities(keyWord);
                }}
                language="en"
                isLoading={medicalServices.status === status.FETCHING}
                extendLoaderStyle={extendLoaderStyle}
                isValid
                extendDropDownStyle={extendSearchDropDownStyle}
                extendDropDownListItem={extendDropDownListItem}
                icon="e905"
              />
            </div>
            {/** Services section */}
            <div
              style={{
                height: 'calc(85vh - 145px)',
              }}
            >
              {selectedServices?.length > 0 && (
                <div>
                  <ItemsContainer>
                    <ItemContainer>
                      <ItemWrapper>Service</ItemWrapper>
                      <ItemWrapper>Price</ItemWrapper>
                    </ItemContainer>
                    {selectedServices?.map(item => {
                      const { serviceName, serviceKey } = item;
                      return (
                        <ServiceRecord
                          key={serviceKey}
                          serviceKey={serviceKey}
                          serviceName={serviceName}
                          servicePrevPrice={item?.prevValue}
                          priceListId={priceListId}
                          servicePrevType={item?.servicePrevType}
                          allowEditType={allowEditServiceType}
                        />
                      );
                    })}
                    {isShowMoreBtnShown && (
                      <Button
                        onClick={() => {
                          onClickShowMore(searchQuery.PageNum + 1);
                        }}
                        btnText="Show more"
                        extendButtonStyle={extendShowMoreButtonStyle}
                        key="dismiss-popup"
                        isLoading={medicalServices.status === status.FETCHING}
                        extendLoaderStyle={extendLoaderStyle}
                      />
                    )}
                  </ItemsContainer>
                </div>
              )}
            </div>
            <ButtonsContainer>
              <Button
                onClick={() => {
                  onClickClose();
                }}
                btnText="Close"
                extendButtonStyle={extendBlueButtonStyle}
                key="dismiss-popup"
              />
            </ButtonsContainer>
          </div>
        </Container>
      </PopupWrapper>
    </Popup>
  );
};

AddPricelistServicesModal.propTypes = {
  onClose: PropTypes.func,
};

export default AddPricelistServicesModal;
